import { Component, OnInit, Inject } from '@angular/core';
import { CommunicationService } from '../../../services/communication/communication.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from '../../../services/http/http.service';
import { forkJoin } from 'rxjs';
import { HelperService } from '../../../util/helper/helper.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-print-custom-data-popup',
  templateUrl: './print-custom-data-popup.component.html',
  styleUrls: ['./print-custom-data-popup.component.scss']
})
export class PrintCustomDataPopupComponent implements OnInit {
  surveys;
  documents;
  questions;
  selectedQuestion: any = {};
  selectedQuestionIndex = 0;
  communicationListener;
  isShowLoader = false;
  constructor(private communicationService: CommunicationService,
    private httpService: HttpService,
    private helper: HelperService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public popupData,
    public dialogRef: MatDialogRef<PrintCustomDataPopupComponent>) {
    this.communicationListener = this.communicationService.getTemplateData.subscribe(res => {
      this.surveys = res.surveys;
      if (this.surveys && this.surveys.length) {
        this.surveys.map(x => {
          x.responses.map(y => {
            y.selected = y.questionnaire.length > 0;
          })
          x.selected = x.responses.findIndex(y => !y.selected) === -1;
        })
      }
      this.documents = res.allDocuments;
      if (this.documents && this.documents.length)
        this.documents.map(x => { x.selected = true });
    })
  }

  ngOnInit(): void {
    this.questions = this.popupData.questions;
    this.selectNextQuestion();
  }

  selectNextQuestion() {
    if (this.selectedQuestionIndex < this.questions.length) {
      this.selectedQuestion = this.questions[this.selectedQuestionIndex];
      this.selectedQuestionIndex++;
      if (this.selectedQuestion.key === 'surveys' && (!this.surveys || !this.surveys.length))
        this.selectNextQuestion();
      if (this.selectedQuestion.key === 'documents' && (!this.documents || !this.documents.length))
        this.selectNextQuestion();
    } else
      this.dialogRef.close({ action: true })
  }

  onClosePopup(): void {
    this.dialogRef.close();
  }

  selectSurvey(survey) {
    survey.selected = !survey.selected;
    survey.responses.map(x => {
      x.selected = survey.selected;
    })
  }

  selectResponse(survey, response) {
    response.selected = !response.selected;
    survey.selected = survey.responses.findIndex(y => !y.selected) === -1;
  }

  onSubmit() {
    if (this.selectedQuestion.key === 'surveys') {
      this.getSelectedSurveys();
    } else if (this.selectedQuestion.key === 'documents') {
      const selectedDocuments = this.documents.filter(x => x.selected);
      this.communicationService.setTemplateData(selectedDocuments, 'documents');
      this.selectNextQuestion();
    }
  }

  getSelectedSurveys() {
    const payload = [];
    this.surveys.map(x => {
      x.responses.map(y => {
        if (y.selected && !y.questionnaire.length)
          payload.push(this.httpService.get(`questionnaire/response/${y.id}`))
      })
    })
    if (payload.length) {
      this.isShowLoader = true;
      forkJoin(payload).subscribe((results: any) => {
        results.map(res => {
          let surveyIndex;
          let responseIndex;
          this.surveys.map((y, i) => {
            const index = y.responses.findIndex(z => z.id === res.id);
            if (index !== -1) {
              responseIndex = index;
              surveyIndex = i;
            }
          })
          this.surveys[surveyIndex].responses[responseIndex].questionnaire = res.survey.filter(x => {
            if (x.answer && x.answer.length && x.type === 'boolean')
              x.answer = [this.getAnswer(x.answer[0])]
            if (x.type === 'reference' && x.intent === 'signature' && x.answer && x.answer.length)
              this.getMedia(x)
            return x.type !== 'display';
          });
          if (res.hiddenFields) {
            this.surveys[surveyIndex].responses[responseIndex].hiddenFields = Object.entries(res.hiddenFields);
          }
        })
        this.communicationService.setTemplateData(this.surveys, 'surveys');
        this.setSurveysToPrint();
        this.selectNextQuestion();
        this.isShowLoader = false;
      }, error => {
        this.isShowLoader = false;
        this.toastr.warning(error, 'Surveys', {
          progressBar: true, timeOut: 3000
        });
      });
    } else {
      this.setSurveysToPrint();
      this.selectNextQuestion();
    }
  }

  setSurveysToPrint() {
    let assessment = [...this.surveys];
    assessment = assessment.filter(x => {
      return x.responses.findIndex(y => y.selected) !== -1;
    })
    this.communicationService.setTemplateData(assessment, 'assessment');
  }

  getAnswer(answer) {
    if (answer === 'true' || answer === true)
      return 'Yes'
    else if (answer === 'false' || answer === false)
      return 'No'
    else
      return answer
  }

  getMedia(data) {
    const id = this.helper.extractId(data.answer[0]);
    this.isShowLoader = true;
    this.httpService.get(`media/${id}`)
      .subscribe((response: any) => {
        this.isShowLoader = false;
        data.src = `data:${response.content.contentType};base64,${response.content.data}`;
      }, () => {
        this.isShowLoader = false;
      })
  }

  ngOnDestroy(): void {
    this.communicationListener.unsubscribe();
  }
}
